import React from 'react'
import PropTypes from 'prop-types'
import { Logo, Row, Column } from 'quantic'

import { Wrapper, FormSection, LogoWrapper } from './styles'

import Background from './Background'
import About from './About'
import Footer from './Footer'

function NotAuthenticatedLayout({ children, hasHelp }) {
  return (
    <Wrapper>
      <Background />
      <About />
      <FormSection>
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <Row>
          <Column size={12}>{children}</Column>
          {hasHelp ? <Footer /> : null}
        </Row>
      </FormSection>
    </Wrapper>
  )
}

NotAuthenticatedLayout.propTypes = {
  children: PropTypes.node.isRequired,
  hasHelp: PropTypes.bool,
}

NotAuthenticatedLayout.defaultProps = {
  hasHelp: false,
}

export default NotAuthenticatedLayout
